// Copyright 2022 - 2023 Fewcha. All rights reserved.

import "@firebase/database";
import { store } from "app/store";
import Router from "components/Router/Router";
import { Provider } from "react-redux";
import { ReactReduxFirebaseProvider } from "react-redux-firebase";
import { firebase } from "services/firebase";

const App: React.FC = () => {
  return (
    <Provider store={store}>
      <ReactReduxFirebaseProvider firebase={firebase} config={{}} dispatch={store.dispatch}>
        <Router />
      </ReactReduxFirebaseProvider>
    </Provider>
  );
};

export default App;
